/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export const useStyles = (props) => ({
    whiteContentTopRadius: css({
        backgroundColor: "#ffffff",
        marginTop: "-10px !important",
        textAlign: "center",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
        paddingBottom: "20px",
        overflow: "hidden",
    }),
    greyContentPlain: css({
        overflow: "auto",
    }),
    greyContent: css({
        backgroundColor: "#f3f6f6",
        overflow: "auto",
        padding: "15px",
    }),
    textInputBox: css({
        fontSize: "12px",
        backgroundColor: "#f3f6f6",
        margin: "4px 6px",
        padding: "10px 15px",
        borderRadius: 5,
        textAlign: "left",
    }),
    headerContentBar: css({
        padding: "8px 15px",
        backgroundColor: "#f3f6f6",
        fontSize: "12px",
        color: "#9D9D9D",
        display: "flex",
        justifyContent: "space-between",
    }),
    noContentBar: css({
        padding: "8px 15px",
        backgroundColor: "#edf2f2",
        fontSize: "12px",
        color: "#9D9D9D",
        textAlign: "center",
    }),
    whiteContentBarWithCloseButton: css({
        backgroundColor: "#ffffff",
        height: "45px",
        display: "flex",
        alignItems: "center",
    }),
    ContentBorder: css({
        height: '4px',
        borderTop: '1px solid #9D9D9D',
        backgroundColor: '#EFEFEF',
    }),
    blackLeftContent: css({
        fontSize: "12px",
        color: "black",
        marginTop: 0,
        textAlign: "left",
        textTransform: "capitalize",
        paddingLeft: "15px",
    }),
    blackRightContent: css({
        fontSize: "11px",
        color: "black",
        marginTop: 0,
        textAlign: "right",
        textTransform: "capitalize",
        paddingLeft: "15px",
    }),
    whiteContentBarCloseButton: css({
        color: "#00a7dd",
        right: 15,
        cursor: "pointer",
    }),
});
